import Country from '~/Api/Country/Country';

import isProductAtcValid from './isProductAtcValid';
import Query from './Query';

export const InvalidValue = 'invalid-value';
export type ErrorCode = typeof InvalidValue;
export interface QueryErrors {
	[field: string]: ErrorCode[];
}

export default function validateQuery(query: Query, countries: Country[]): QueryErrors {
	const { filterParameters } = query;
	const errors: { [field: string]: ErrorCode[] } = {};

	if (filterParameters.find((parameter) => parameter.value !== '' || parameter.name === 'datasource') === undefined) {
		const firstParameter = filterParameters.length > 0 ? filterParameters[0] : null;
		errors[firstParameter !== null ? firstParameter.name : 'all'] = [InvalidValue];
	}

	const atcParameter = filterParameters.find((parameter) => parameter.name === 'atc');
	if (
		atcParameter !== undefined &&
		!Array.isArray(atcParameter.value) &&
		!isProductAtcValid(atcParameter.value.toUpperCase())
	) {
		errors.atc = [InvalidValue];
	}

	const newerThanParameter = filterParameters.find((parameter) => parameter.name === 'newerThan');
	if (newerThanParameter !== undefined && newerThanParameter.parseDateValue() === null) {
		errors.newerThan = [InvalidValue];
	}

	const countryParameter = filterParameters.find((parameter) => parameter.name === 'country');
	if (
		countryParameter !== undefined &&
		Array.isArray(countryParameter.value) &&
		countryParameter.value.find((code) => countries.find((country) => country.alpha2 === code) === undefined) !==
			undefined
	) {
		errors.country = [InvalidValue];
	}

	return errors;
}
